import { useTaxonomyStore } from '@modules/taxonomy/store/taxonomyStore';

import { GetAggregatesResponse } from 'generated/graphql';
import useExecuteEQL from 'v2/core/repository/edge-server/eql/useExecuteEQL';
import { IsLoading, QueryStatus } from 'v2/core/repository/edge-server/types';
import { ExpressionType } from 'v2/core/repository/eql/types';
import { QueryContainer } from 'v2/core/services/notebook/types';
import { useGetUser } from 'v2/core/services/user';

interface UseFetchRecordCountOptions {
  queryContainer: QueryContainer;
  skip?: boolean;
}

export function useFetchRecordCount({
  queryContainer,
  skip,
}: UseFetchRecordCountOptions) {
  const taxonomyID = useTaxonomyStore(({ taxonomyID }) => taxonomyID ?? '');
  const {
    tenant: { id: tenantID, timezone },
  } = useGetUser();

  const recordsEql = {
    expressionType: ExpressionType.Aggregates,
    timezone,
    taxonomyID,
    dateRange: queryContainer.DateRange,
    whereClause: queryContainer.WhereClause,
  };

  const { data, error, status, refetch } = useExecuteEQL({
    input: {
      tenantID,
      eqlProps: recordsEql,
    },
    options: {
      FetchPolicy: 'cache-and-network',
      Skip: skip,
    },
  });

  const getAggregates = data as GetAggregatesResponse;

  return {
    error,
    status,
    data:
      status === QueryStatus.SUCCESS_COMPLETED
        ? getAggregates?.data?.[0]?.value
        : undefined,
    refetch,
    isLoading: IsLoading(status),
  };
}
